import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PollComponentsModule } from './components/poll-components.module';
import { PollPage } from './poll';

@NgModule({
  declarations: [
    PollPage
  ],
  exports : [
    PollPage
  ],
  imports: [
    IonicPageModule.forChild(PollPage),
    PollComponentsModule
  ]
})
export class PollPageModule {}



// WEBPACK FOOTER //
// ./src/pages/poll/poll.module.ts